import { Component } from '@angular/core';

@Component({
  selector: 'app-other-sources-info-modal',
  templateUrl: './other-sources-info-modal.component.html',
  standalone: false
})
export class OtherSourcesInfoModalComponent {

}
